import LucideGlyph from 'lucide-react/dist/esm/icons/x.mjs';
import type { JSX } from 'react';
import { Icon } from '../../Icon/Icon.js';
import type { IconProps } from '../../Icon/Icon.js';

export function ClearIcon(props: IconProps): JSX.Element {
  return <Icon glyph={LucideGlyph} size={16} fillable={false} {...props} />;
}
